<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="false"
    :fields="fields"
    :list-route-name="listRouteName"
    :item-id="$route.params.id"
  >
    <!-- Текущий ключ показываем только маской; сам ключ бэк наружу не отдаёт -->
    <template #field.secretKeyLast4="{ item }">
      <read-only-text-field
        label="Текущий секретный ключ ЮKassa"
        :value="item.secretKeyLast4 ? `задан ••••${item.secretKeyLast4}` : null"
      />
    </template>

    <template #field.yookassaSecretKey="{ item }">
      <v-text-field
        v-model="item.yookassaSecretKey"
        label="Новый секретный ключ ЮKassa"
        hint="Оставьте пустым, чтобы не менять ключ"
        persistent-hint
        outlined
      />
    </template>
  </entity-edit-form>
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm.vue'
  import ReadOnlyTextField from '@/components/ui/crud/fields/ReadOnlyTextField.vue'
  import FaktLegalEntityDataService from '@/services/api/FaktLegalEntityDataService'
  import RouteName from '@/models/enums/RouteName'
  import { faktLegalEntityFields } from './faktLegalEntityFields'

  export default {
    name: 'FaktLegalEntitySingle',
    components: { EntityEditForm, ReadOnlyTextField },
    data () {
      return {
        title: 'Редактирование юрлица FAKT',
        listRouteName: RouteName.AdministrationFaktLegalEntities,
        dataService: FaktLegalEntityDataService,
        fields: faktLegalEntityFields({ isCreate: false }),
      }
    },
  }
</script>
